{{ amount | currency:'EUR':'symbol':'1.0-2' }}
